import { transformBaseScheduleShift } from '../BaseScheduleShift/BaseScheduleShiftTransformers'
import { transformDepartmentIndexV3Resource } from '../Department/DepartmentTransformers'
import { transformUserWithPersonV3Resource } from '../User/UserTransformers'
import {
    BaseScheduleDayComment,
    BaseScheduleDayCommentCreatedResource,
    BaseScheduleDayCommentResource,
    BaseScheduleDetail,
    BaseScheduleDetailResource,
    BaseScheduleFormData,
    BaseScheduleIndex,
    BaseScheduleIndexResource,
    CreateBaseScheduleRequest,
    PatchBaseScheduleRequest,
} from './BaseSchedule'

export const transformBaseScheduleDayComment = (
    resource: BaseScheduleDayCommentResource,
): BaseScheduleDayComment => ({
    id: resource.uuid,
    body: resource.body,
    dayNumber: resource.dayNumber,
    ...(resource.owner && { owner: transformUserWithPersonV3Resource(resource.owner) }),
})

export const transformBaseScheduleDayCommentCreated = (
    resource: BaseScheduleDayCommentCreatedResource,
): BaseScheduleDayComment => ({
    id: resource.commentUuid,
    body: resource.body,
    dayNumber: resource.dayNumber,
})

export const transformBaseScheduleIndex = (
    resource: BaseScheduleIndexResource,
): BaseScheduleIndex => ({
    id: resource.uuid,
    name: resource.name,
    totalWeeks: resource.totalWeeks,
    createdBy: resource.createdBy,
    departments: resource.departments.map(transformDepartmentIndexV3Resource),
})

export const transformBaseScheduleDetail = (
    resource: BaseScheduleDetailResource,
): BaseScheduleDetail => ({
    id: resource.uuid,
    name: resource.name,
    totalWeeks: resource.totalWeeks,
    dayComments: resource.dayComments.map(transformBaseScheduleDayComment),
    shifts: resource.shifts.map(transformBaseScheduleShift),
})

export const transformBaseScheduleFormDataToCreateRequest = (
    formData: BaseScheduleFormData,
): CreateBaseScheduleRequest => ({
    name: formData.name,
    ...(formData.totalWeeks && { totalWeeks: formData.totalWeeks }),
})

export const transformBaseScheduleFormDataToPatchRequest = (
    formData: Partial<BaseScheduleFormData>,
): PatchBaseScheduleRequest => ({
    ...(formData.name && { name: formData.name }),
    ...(formData.totalWeeks && { totalWeeks: formData.totalWeeks }),
})
